import qs from "qs";

import { URLS } from "globalConstants";
import {
	authHeader,
	axios,
	axiosWithAuth,
	encodeObjToURI,
	history,
} from "helpers";

export const userService = {
	checkCredentials,
	checkUsername,
	forgotPassword,
	getPermissions,
	getProfile,
	getRefreshedTokens,
	login,
	logout,
	resetPassword,
	verifyCode,
};

const API_URL = process.env.REACT_APP_API_URL;

function getPermissions() {
	const options = {
		url: `${API_URL}/api/me/profile/permissions`,
		method: "GET",
	};

	return axiosWithAuth(options);
}

function getProfile() {
	const requestOptions = {
		url: `${API_URL}/profile`,
		method: "GET",
		headers: authHeader(),
	};

	return axios(requestOptions).then(res => res.data);
}

// Login services
function login(username, password, deviceId, email, code) {
	const requestOptions = {
		url: `${API_URL}/api/token`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		data: qs.stringify({
			username,
			password,
			deviceId,
			email,
			code,
		}),
	};
	return axios(requestOptions).then(res => {
		if (!(res.status === 201)) {
			localStorage.setItem("user", JSON.stringify(res.data));
		}
		return {
			data: res.data,
		};
	});
}

function checkUsername(username) {
	const requestOptions = {
		url: `${API_URL}/api/token`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		data: qs.stringify({
			username,
		}),
	};
	return axios(requestOptions).then(res => res.data);
}

function forgotPassword(username, email, userId) {
	const data = userId ? { userId } : { username, email };

	const requestOptions = {
		url: `${API_URL}/api/forgot-password`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		data: qs.stringify(data),
	};
	return axios(requestOptions).then(res => res.data);
}

function resetPassword(userId, code, password) {
	const requestOptions = {
		url: `${API_URL}/api/reset-password`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		data: qs.stringify({
			userId,
			password,
			code,
		}),
	};
	return axios(requestOptions).then(res => res.data);
}

function logout() {
	history.push(URLS.login);
}

function getRefreshedTokens(refreshToken) {
	const options = {
		method: "POST",
		data: encodeObjToURI({
			refresh_token: refreshToken,
		}),
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		url: `${API_URL}/api/token/refresh`,
	};

	return axios(options);
}

function verifyCode(userId, code) {
	const options = {
		url: `${API_URL}/api/forgot-password/verify-code`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		data: qs.stringify({
			userId,
			code,
		}),
	};

	return axios(options).then(res => res.data);
}

function checkCredentials({ username, password }) {
	const options = {
		url: `${API_URL}/api/token/check_credentials`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		data: qs.stringify({
			username,
			password,
		}),
	};

	return axios(options);
}
